import '../scss/footer.style.scss';
const Invozio_logo = '/assets/png/white_logo.png';
const oneclickBtn = '/assets/svg/one-click-btn.svg';
import { FooterLinkList } from './footerlinks';
import { companyLinks, quickLinks, infoLinks, legalLinks } from '../constant/footer.constant';
import { socialIcons } from '../constant/social-icon.constant';
import { useTranslation } from 'react-i18next';
import { getItem, getLocalizedPathFromLocalStorage } from './../helper/localstorage.helper';
import { Link, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

export const Footer = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const isMobile = window.innerWidth < 576;
    const isLaptop = window.innerWidth >= 992 && window.innerWidth < 1440;
    const footerLinkGroups = [
        { title: t('QUICK_LINKS'), links: quickLinks },
        { title: t('INFORMATION'), links: infoLinks },
        { title: t('LEGAL'), links: legalLinks },
    ];
    const [showButton, setShowButton] = useState(false);
    useEffect(() => {
        const handleScroll = () => {
            setShowButton(window.scrollY > 100);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <>
            <footer className=" d-flex flex-column justify-content-center align-items-center px-0 p-0" >
                <div className="container py-0">
                    <div className='line d-sm-block d-none' />
                    <div className="row padding-between-footer">
                        <div className="col-lg-3 mb-sm-4 mb-5 px-0 ">
                            <ul>
                                <h6 className="footer-title">{t('COMPANY_INFORMATION')}</h6>
                                {companyLinks.map((item, idx) => (
                                    <li key={item.label || idx} className='my-3 dflex align-items-center px-0'>
                                        <Link
                                            to={item.link ? item.link : '#'}
                                            target={item.link ? '_blank' : undefined}
                                            rel={item.link ? 'noreferrer' : undefined}
                                            className='comp-information '
                                            onClick={(!item.link && (item.en && item.sv)) ? (e) => {
                                                e.preventDefault();
                                                navigate(
                                                    getLocalizedPathFromLocalStorage(
                                                        { get: (key: string) => getItem(key) ?? null },
                                                        {
                                                            'sv-se': item.sv,
                                                            'en-us': item.en
                                                        }
                                                    )
                                                );
                                            } : undefined}
                                        >
                                            {t(item.label)}
                                            {item.icon && !isMobile && (
                                                <img src={item.icon} alt="" className='mx-1 mb-1 ' />
                                            )}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        {footerLinkGroups.map((group, idx) => (
                            <div className={`col-lg-2 mb-4 px-0 ${isLaptop}`} key={group.title}>
                                <FooterLinkList
                                    title={group.title}
                                    links={group.links.map(link => ({ ...link, label: t(link.label) }))}
                                />
                            </div>
                        ))}
                        <div className="col-lg-3 mb-4 px-0">
                            <h6 className="footer-title mb-3">{t('CUSTOMER_SUPPORT')}</h6>
                            <ul className="footer-links">
                                <li className='mb-3 px-0'>
                                    <strong>{t('PHONE')}:</strong> 010–264 88 10
                                </li>
                                <li className='mb-3 px-0'>
                                    <strong>{t('EMAIL')}:</strong> support@invozio.com
                                </li>
                                <li className="footer-desc px-0 small footer-text text-light mb-3" style={{ fontWeight: 400, fontSize: "18px", color: "#bdb8d0" }}>
                                    {t('SUPPORT_ISSUES')}
                                </li>
                                <li className="small px-0 footer-text text-light mb-3" style={{ fontWeight: 400, fontSize: "18px", color: "#bdb8d0" }}>
                                    {t('SUPPORT_HOURS')} <br /> {t('CLOSED_ON')}
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className='line d-sm-block d-none' />
                    <div className="d-flex flex-column-reverse  flex-md-row justify-content-between align-items-center  gap-3 footer-top my-4 ">
                        {/* Logo Section */}
                        <div className="footer-logo mb-3 mb-md-0 ">
                            <img src={Invozio_logo} alt="Invozio Logo" height="35" className="footer-logo-img" />
                        </div>
                        {/* Social Section */}
                        <div className="d-flex flex-column-reverse flex-md-row align-items-center gap-3 py-3 pe-0 pe-md-5">
                            <span className="mr-2 footer-text d-sm-block d-none text-light footer-text">{t('FOLLOW_US_ON')}</span>
                            <div className="d-flex align-items-center  footer-link-white gap-3">
                                {socialIcons.map((item, idx) => (
                                    <Link
                                        key={item.ariaLabel}
                                        to={item.link}
                                        target="_blank"
                                        rel="noreferrer"
                                        aria-label={item.ariaLabel}
                                        className="footer-link-white bg-light border"
                                    >
                                        <img src={item.icon} alt="" className='' />
                                    </Link>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
            {showButton && (
                <div className='position-fixed one-click-btn-bottom w-25 ml-sm-5  ml-0'>
                    <button 
                        type="button"
                        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                        style={{ 
                            border: 'none', 
                            background: 'transparent', 
                            padding: 0, 
                            cursor: 'pointer' 
                        }}
                        aria-label="Scroll to top"
                    >
                        <img src={oneclickBtn} alt="" className='one-click-btn' />
                    </button>
                </div>
            )}
        </>
    );
};